import { useCallback, useMemo, useState } from "react";
import cn from "classnames";
import { SquareButton, useJobAlertHistory } from "@themuse/design-system";
import { IconBell } from "@themuse/design-system/lib/components/Icons";
import { JobAlertsModal } from "../Modals";
import { SearchHeaderProps } from "./SearchHeader";
import styles from "./AlertCTA.module.scss";

type AlertCTAProps = Omit<SearchHeaderProps, "state">;

export const AlertCTA = ({
    category, company, keyword, level, location
}: AlertCTAProps) => {
    const { filterKey, filterProps } = useMemo(() => {
        if ([category, keyword, level, location].every((s) => !s) || company) {
            return { filterKey: "empty", filterProps: null };
        }

        const props: Record<string, string> = Object.entries({
            category,
            keyword,
            level,
            location,
        }).reduce((accum, [key, value]) => {
            if (value) {
                return { ...accum, [key]: value };
            }
            return accum;
        }, {});

        return {
            filterKey: new URLSearchParams(props).toString(),
            filterProps: props,
        };
    }, [category, company, keyword, level, location]);
    const { append, hasAlert } = useJobAlertHistory(filterProps);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const handleSubscribed = useCallback(() => {
        append(filterProps);
    }, [append, filterProps]);

    return (
        <>
            <SquareButton
                className={cn(styles.alertCTA, {
                    [styles.alertCTAHidden]: !filterProps,
                })}
                color="light-blue"
                data-testid="alert-cta__button"
                disabled={hasAlert || !filterProps}
                onClick={() => setModalOpen(true)}
            >
                Set Job Alert
                <IconBell />
            </SquareButton>
            <JobAlertsModal
                filterProps={filterProps || {}}
                isOpen={modalOpen}
                key={filterKey}
                onSubscribed={handleSubscribed}
                setIsOpen={setModalOpen}
            />
        </>
    );
};
